{
  "PROFILE_SETTINGS": {
    "LINK": "Configuració del Perfil",
    "TITLE": "Configuració del Perfil",
    "BTN_TEXT": "Actualització del Perfil",
    "DELETE_AVATAR": "Suprimeix Avatar",
    "AVATAR_DELETE_SUCCESS": "L'avatar s'ha suprimit correctament",
    "AVATAR_DELETE_FAILED": "S'ha produït un error en suprimir l'avatar, torneu-ho a provar",
    "UPDATE_SUCCESS": "El teu perfil s'ha actualitzat correctament",
    "PASSWORD_UPDATE_SUCCESS": "La teva contrasenya ha estat canviada correctament",
    "AFTER_EMAIL_CHANGED": "El vostre perfil s'ha actualitzat correctament. Torneu a iniciar la sessió ja que les vostres credencials d'inici de sessió han canviat",
    "FORM": {
      "PICTURE": "Imatge de perfil",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Imatge de la signatura de correu electrònic",
        "HINT": "S'utilitza a les signatures de correu electrònic. {'{{'}email_signature_picture{'}}'} se substitueix per l'URL d'aquesta imatge (no una etiqueta d'imatge) — utilitza-la com a font d'imatge (l'atribut src d'una etiqueta img) a la teva signatura o a la signatura de la safata d'entrada. Si no s'estableix, no s'insereix res.",
        "DELETE_SUCCESS": "La imatge de la signatura de correu electrònic s'ha eliminat correctament",
        "DELETE_FAILED": "S'ha produït un error en eliminar la imatge de la signatura de correu electrònic, torna-ho a provar"
      },
      "AVATAR": "Imatge del Perfil",
      "ERROR": "Corregiu els errors del formulari",
      "REMOVE_IMAGE": "Suprimeix",
      "UPLOAD_IMAGE": "Puja imatge",
      "UPDATE_IMAGE": "Puja imatge",
      "PROFILE_SECTION": {
        "TITLE": "Perfil",
        "NOTE": "La vostra adreça de correu electrònic és la vostra identitat i s'utilitza per iniciar la sessió."
      },
      "SEND_MESSAGE": {
        "TITLE": "Tecla d'accés ràpid per enviar missatges",
        "NOTE": "Pots seleccionar una tecla d'accés ràpid (Enter o Cmd/Ctrl+Enter) segons les teves preferències d'escriptura.",
        "UPDATE_SUCCESS": "La teva configuració s'ha actualitzat correctament",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Retorn (↵)",
            "CONTENT": "Envia missatges prement la tecla Intro en comptes de fer clic al botó d'enviament."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Envia missatges prement Cmd/Ctrl + tecla Intro en lloc de fer clic al botó d'enviament."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Personalitzeu l'aspecte del vostre tauler de control.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Per defecte",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Idioma del tauler",
          "NOTE": "Sobreescriu l'idioma del compte per al teu propi tauler. Deixa-ho buit per utilitzar el predeterminat del compte.",
          "USE_ACCOUNT_DEFAULT": "Utilitza el predeterminat del compte",
          "API_SUCCESS": "L'idioma del teu tauler s'ha actualitzat correctament"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Idioma del missatge",
          "NOTE": "Tria si vols mostrar els missatges originals o les seves traduccions",
          "ORIGINAL": "Original",
          "TRANSLATED": "Traduït"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Comportament en enganxar",
          "NOTE": "Tria com s'ha de processar el contingut enganxat en redactar missatges",
          "UPDATE_SUCCESS": "La configuració d'enganxar s'ha actualitzat correctament",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Conserva tot el format",
              "DESCRIPTION": "Conserva tot el format en enganxar contingut, incloses taules, estils i altres elements HTML."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Només text amb enllaços",
              "DESCRIPTION": "Converteix a text sense format però conserva els enllaços en enganxar contingut."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Només text sense format",
              "DESCRIPTION": "Elimina tot el format i converteix a text sense format en enganxar contingut."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Alçada del quadre de resposta",
          "NOTE": "Estableix l'alçada mínima del quadre de resposta com a percentatge de l'alçada de la pantalla. Només s'aplica a les converses de correu electrònic.",
          "UPDATE_SUCCESS": "La configuració de l'alçada del quadre de resposta s'ha actualitzat correctament",
          "PERCENT_LABEL": "Alçada (% de l'alçada de la pantalla)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Per defecte",
              "DESCRIPTION": "El quadre de resposta comença petit i creix a mesura que escrius."
            },
            "CUSTOM": {
              "HEADING": "Personalitzat",
              "DESCRIPTION": "El quadre de resposta sempre té com a mínim el percentatge triat de l'alçada de la pantalla."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Vés automàticament a la conversa següent",
        "NOTE": "Canvia automàticament a la conversa oberta següent després de resoldre l'actual",
        "UPDATE_SUCCESS": "La configuració de navegació automàtica s'ha actualitzat correctament"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Signatura personal del missatge",
        "DESCRIPTION": "Crea una signatura de missatge única perquè aparegui al final de cada correu que enviïs. També hi pots incloure una imatge en línia.",
        "NOTE": "Crea una signatura de missatge única per aparèixer al final de cada missatge que envieu des de qualsevol safata d'entrada. També pots incloure una imatge en línia, que és compatible amb el xat en directe, el correu electrònic i les bústies d'entrada de l'API.",
        "BTN_TEXT": "Desa la signatura del missatge",
        "API_ERROR": "No s'ha pogut desar la signatura! Torna-ho a provar",
        "API_SUCCESS": "La signatura s'ha desat correctament",
        "IMAGE_UPLOAD_ERROR": "No s'ha pogut carregar la imatge! Torna-ho a provar",
        "IMAGE_UPLOAD_SUCCESS": "La imatge s'ha afegit correctament. Fes clic a desa per desar la signatura",
        "IMAGE_UPLOAD_SIZE_ERROR": "La mida de la imatge ha de ser inferior a {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Signatura del missatge",
        "ERROR": "La signatura del missatge no pot estar buida",
        "PLACEHOLDER": "Introdueix aquí la teva signatura de missatge personal."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Contrasenya",
        "NOTE": "L'actualització de la contrasenya restableix els vostres inicis de sessió en múltiples dispositius.",
        "BTN_TEXT": "Canvia la contrasenya"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Token d'accés",
        "NOTE": "Aquest token es pot utilitzar si creeu una integració basada en l'API",
        "COPY": "Copia",
        "REGENERATE": "Regenera",
        "REGENERATE_SUCCESS": "El token d'accés s'ha regenerat correctament. Actualitza les integracions que utilitzin el token antic.",
        "REGENERATE_CONFIRM_TITLE": "Vols regenerar el token d'accés?",
        "REGENERATE_CONFIRM_MESSAGE": "Això invalidarà el token actual. Les integracions que utilitzin el token antic deixaran de funcionar."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Extensió de Chrome",
        "NOTE": "Instal·la la nostra extensió de Chrome per rebre notificacions detallades de les trucades entrants.",
        "INSTALL_BUTTON": "Instal·la l'extensió",
        "ALREADY_INSTALLED": "Extensió instal·lada"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "Ningú",
          "MINE": "Assignat",
          "ALL": "Totes",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Esdeveniments d'alerta per a converses",
          "NONE": "Ningú",
          "ASSIGNED": "Converses assignades",
          "ALL_CONVERSATIONS": "Totes les converses"
        },
        "DEFAULT_TONE": {
          "TITLE": "To d'alerta:"
        },
        "CONDITIONS": {
          "TITLE": "Condicions d'alerta:",
          "CONDITION_ONE": "Envia alertes d'àudio només si la finestra del navegador no està activa",
          "CONDITION_TWO": "Envia alertes cada 30 segons fins que es llegeixin totes les converses assignades"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Llegir més"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Notificacions per correu electrònic",
        "NOTE": "Actualitza aqui les preferències de les notificacions per correu electrònic",
        "CONVERSATION_ASSIGNMENT": "Envieu notificacions per correu electrònic quan se m’assigni una conversa",
        "CONVERSATION_CREATION": "Envieu notificacions per correu electrònic quan es crea una nova conversa",
        "CONVERSATION_MENTION": "Enviar notificacions per mail quan siguis esmentat en una conversació",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Envia notificacions per correu electrònic quan es creï un missatge nou en una conversa assignada",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Envia notificacions per correu electrònic quan es crea un missatge nou en una conversa participant",
        "SLA_MISSED_FIRST_RESPONSE": "Envia notificacions per correu electrònic quan una conversa no compleixi un SLA de primera resposta",
        "SLA_MISSED_NEXT_RESPONSE": "Envia notificacions per correu electrònic quan una conversa es perdi la següent resposta SLA",
        "SLA_MISSED_RESOLUTION": "Envia notificacions per correu electrònic quan una conversa no resol un SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Preferències de notificació",
        "TYPE_TITLE": "Tipus de notificació",
        "EMAIL": "Correu electrònic",
        "PUSH": "Notificació Push",
        "TYPES": {
          "CONVERSATION_CREATED": "S'ha creat una nova conversa",
          "CONVERSATION_ASSIGNED": "Se t'assigna una conversa",
          "CONVERSATION_MENTION": "Se't menciona en una conversa",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Es crea un missatge nou en una conversa assignada",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Es crea un missatge nou en una conversa participant",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Es crea un missatge nou en una conversa sense cap agent disponible",
          "SLA_MISSED_FIRST_RESPONSE": "Una conversa no té un SLA de primera resposta",
          "SLA_MISSED_NEXT_RESPONSE": "SLA de la següent resposta no és una conversa",
          "SLA_MISSED_RESOLUTION": "Una conversa no resol un SLA"
        },
        "BROWSER_PERMISSION": "Activa les notificacions push en el teu navegador perquè puguis rebre-les",
        "ALLOW_NOTIFICATION_DURING_CALL": "Permet les notificacions push mentre estàs en una trucada",
        "TEST_PUSH": "Prova",
        "TESTING": "S'està provant...",
        "TEST_PUSH_DESCRIPTION": "Envia notificacions de prova per verificar la configuració",
        "TEST_NOTIFICATION_ERROR": "No s'ha pogut enviar la notificació de prova. Torna-ho a provar.",
        "TEST_LOCAL_TITLE": "Notificació de prova (local)",
        "TEST_LOCAL_BODY": "Aquesta és una notificació local del navegador. Si la veus, les notificacions del navegador funcionen!"
      },
      "API": {
        "UPDATE_SUCCESS": "Les teves preferències de notificació s’han actualitzat correctament",
        "UPDATE_ERROR": "Hi ha un error en actualitzar les preferències; tornau-ho a provar"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Notificacions automàtiques",
        "NOTE": "Actualitzeu les preferències de notificació aquí",
        "CONVERSATION_ASSIGNMENT": "Envia notificacions automàtiques quan se m'assigna una conversa",
        "CONVERSATION_CREATION": "Envia notificacions automàtiques quan es creï una conversa nova",
        "CONVERSATION_MENTION": "Enviar notificacions push quan siguis esmentat en una conversació",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Envia notificacions automàtiques quan es creï un missatge nou en una conversa assignada",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Envia notificacions push quan es crea un missatge nou en una conversa participant",
        "HAS_ENABLED_PUSH": "Heu activat les notificacions per a aquest navegador.",
        "REQUEST_PUSH": "Activa les notificacions",
        "SLA_MISSED_FIRST_RESPONSE": "Envia notificacions automàtiques quan una conversa no tingui un SLA de primera resposta",
        "SLA_MISSED_NEXT_RESPONSE": "Envia notificacions automàtiques quan una conversa no s'aconsegueixi la següent resposta SLA",
        "SLA_MISSED_RESOLUTION": "Envia notificacions quan una conversa no resol el SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Imatge del Perfil"
      },
      "NAME": {
        "LABEL": "El teu nom complet",
        "ERROR": "Introdueix un nom complet vàlid",
        "PLACEHOLDER": "Introdueix el vostre nom complet"
      },
      "DISPLAY_NAME": {
        "LABEL": "Nom visible",
        "ERROR": "Introduïu un nom de visualització vàlid",
        "PLACEHOLDER": "Introdueix un nom visible, que es mostrarà a les converses"
      },
      "POSITION": {
        "LABEL": "Càrrec",
        "ERROR": "Introdueix un càrrec vàlid",
        "PLACEHOLDER": "Introdueix el teu càrrec"
      },
      "CUSTOM_LINE": {
        "LABEL": "Línia personalitzada",
        "ERROR": "Introdueix una línia personalitzada vàlida",
        "PLACEHOLDER": "Introdueix la teva línia personalitzada"
      },
      "AVAILABILITY": {
        "LABEL": "Disponibilitat",
        "STATUS": {
          "ONLINE": "En línia",
          "BUSY": "Ocupat",
          "OFFLINE": "Fora de línia"
        },
        "SET_AVAILABILITY_SUCCESS": "La disponibilitat s'ha establert correctament",
        "SET_AVAILABILITY_ERROR": "No s'ha pogut establir la disponibilitat, torna-ho a provar"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Format de la vista prèvia del correu electrònic a la llista de converses",
        "NOTE": "Tria què es mostra a la llista de converses per a les converses de safates d'entrada de correu electrònic",
        "SUBJECT": "Assumpte",
        "SUBJECT_WITH_NOTE": "Assumpte i l'últim missatge si és una nota interna",
        "UPDATE_SUCCESS": "La configuració de vista prèvia de correu electrònic s'ha actualitzat correctament"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Desactiva les dreceres de teclat",
        "NOTE": "Desactiva totes les dreceres de teclat de l'aplicació",
        "UPDATE_SUCCESS": "La configuració de les dreceres de teclat s'ha actualitzat correctament"
      },
      "FOLDER_ORDER": {
        "TITLE": "Ordre de les carpetes",
        "NOTE": "Personalitza l'ordre en què apareixen les carpetes (vistes personalitzades) a la barra lateral. Arrossega-les per reordenar-les.",
        "NO_FOLDERS": "No s'ha trobat cap carpeta personalitzada. Crea'n per organitzar les teves converses."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Configuració de la barra lateral",
        "NOTE": "Personalitza quines seccions apareixen a la barra lateral de converses.",
        "SAVE_BUTTON": "Desa la configuració",
        "UPDATE_SUCCESS": "La configuració de la barra lateral s'ha actualitzat correctament",
        "UPDATE_ERROR": "S'ha produït un error en actualitzar la configuració de la barra lateral. Torna-ho a provar.",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Totes les converses",
          "ALL_CONVERSATIONS_DESC": "Mostra l'element de menú Totes les converses a la barra lateral",
          "INBOX": "Safata d'entrada",
          "INBOX_DESC": "Mostra la safata d'entrada principal amb les notificacions no llegides",
          "CONVERSATION_GROUPS": "Mencions i sense assistència",
          "CONVERSATION_GROUPS_DESC": "Mostra els grups de converses Mencions i Sense assistència",
          "FOLDERS": "Carpetes",
          "FOLDERS_DESC": "Mostra vistes personalitzades (carpetes) per organitzar les converses",
          "TEAMS": "Equips",
          "TEAMS_DESC": "Mostra les converses filtrades per assignació d'equip",
          "CHANNELS": "Safates d'entrada",
          "CHANNELS_DESC": "Mostra les converses filtrades per safata d'entrada",
          "LABELS": "Etiquetes",
          "LABELS_DESC": "Mostra les converses filtrades per etiquetes"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Configuració del telèfon",
        "NOTE": "Introdueix les credencials d'accés al teu sistema PBX.",
        "USERNAME": "Nom d'usuari",
        "PASSWORD": "Contrasenya",
        "SUBMIT": "Desa",
        "USERNAME_INVALID": "El nom d'usuari només pot contenir lletres, xifres i . _ - + (sense espais ni adreces de correu electrònic).",
        "API": {
          "USERNAME_INVALID": "El nom d'usuari no és un nom d'usuari SIP vàlid. Utilitza només lletres, xifres i . _ - + (sense espais ni adreces de correu electrònic).",
          "USERNAME_TAKEN": "Un altre agent d'aquest compte ja utilitza aquest nom d'usuari."
        }
      },
      "EMAIL": {
        "LABEL": "La teva adreça de correu electrònic",
        "ERROR": "Introduïu una adreça de correu electrònic vàlida",
        "PLACEHOLDER": "Introduïu la vostra adreça de correu electrònic, que es mostrarà a les converses"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Contrasenya actual",
        "ERROR": "Introdueix la contrasenya actual",
        "PLACEHOLDER": "Introdueix la contrasenya actual"
      },
      "PASSWORD": {
        "LABEL": "Nova contrasenya",
        "ERROR": "Introduïu una contrasenya d'una longitud de 6 o més",
        "PLACEHOLDER": "Introduïu una nova contrasenya"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Confirmació de la nova contrasenya",
        "ERROR": "Confirmeu que les contrasenyes coincideixin",
        "PLACEHOLDER": "Torna a introduir la nova contrasenya"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Canvia",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Informa d'un error",
    "SELECTOR_SUBTITLE": "Selecciona un compte de la llista següent",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Informa d'un error",
    "DESCRIPTION_LABEL": "Descripció del problema",
    "DESCRIPTION_PLACEHOLDER": "Descriu el problema que has trobat...",
    "SUBMIT": "Envia l'informe",
    "SUBMITTING": "S'està enviant...",
    "CANCEL": "Cancel·la",
    "SUCCESS": "S'ha enviat l'informe d'error correctament. Gràcies!",
    "VALIDATION_ERROR": "Descriu el problema abans d'enviar-lo"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "dies de prova restants.",
    "TRAIL_BUTTON": "Compra ara",
    "DELETED_USER": "Usuari suprimit",
    "EMAIL_VERIFICATION_PENDING": "Sembla que encara no has verificat la teva adreça de correu electrònic. Comprova la teva safata d'entrada per trobar el correu electrònic de verificació.",
    "RESEND_VERIFICATION_MAIL": "Reenviar correu electrònic de verificació",
    "EMAIL_VERIFICATION_SENT": "S'ha enviat un correu electrònic de verificació. Comprova la teva safata d'entrada.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Compte suspès",
      "MESSAGE": "El teu compte està suspès. Posa't en contacte amb l'equip d'assistència per obtenir més informació."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Copia",
      "CODEPEN": "Obre en CodePen",
      "COPY_SUCCESSFUL": "El codi s'ha copiat al porta-retalls amb èxit"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Mostra més",
      "SHOW_LESS": "Mostra menys"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Descarrega",
      "UPLOADING": "S'està carregant...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Aquesta història ja no està disponible.",
      "RECORDING_UNAVAILABLE": "Aquesta gravació ja no està disponible.",
      "DELETE_RECORDING": {
        "BUTTON": "Elimina l'enregistrament de la trucada",
        "TITLE": "Vols eliminar l'enregistrament de la trucada?",
        "DESCRIPTION": "Tots els enregistraments d'aquesta trucada s'eliminaran permanentment de la centraleta telefònica i no es podran recuperar. La transcripció i el resum de la trucada es conservaran.",
        "CONFIRM": "Elimina",
        "SUCCESS": "Enregistrament de la trucada eliminat",
        "ERROR": "No s'ha pogut eliminar l'enregistrament de la trucada. Torna-ho a provar."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Veure al mapa"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Envia"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "S'està verificant...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Afegeix Safata d'entrada"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Visualització actual:",
    "SWITCH": "Canvia",
    "INBOX_VIEW": "Vista de la safata d'entrada",
    "CONVERSATIONS": "Converses",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "Totes les converses",
    "MENTIONED_CONVERSATIONS": "Mencions",
    "PARTICIPATING_CONVERSATIONS": "Participant",
    "UNATTENDED_CONVERSATIONS": "Sense assistència",
    "REPORTS": "Informes",
    "SETTINGS": "Configuracions",
    "CONTACTS": "Contactes",
    "DATA_ASSISTANT": "Assistent de dades",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Inici",
    "AGENTS": "Agents",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Registres d'auditoria",
    "WHATSAPP_TEMPLATES": "Plantilles de WhatsApp",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Safates d'entrada",
    "NOTIFICATIONS": "Notificacions",
    "CANNED_RESPONSES": "Respostes predeterminades",
    "INTEGRATIONS": "Integracions",
    "PROFILE_SETTINGS": "Configuració del Perfil",
    "ACCOUNT_SETTINGS": "Configuració del compte",
    "APPLICATIONS": "Aplicacions",
    "LABELS": "Etiquetes",
    "CUSTOM_ATTRIBUTES": "Atributs personalitzats",
    "AUTOMATION": "Automatització",
    "MACROS": "Macros",
    "TEAMS": "Equips",
    "BILLING": "Facturació",
    "CUSTOM_VIEWS_FOLDER": "Carpetes",
    "CUSTOM_VIEWS_SEGMENTS": "Segments",
    "ALL_CONTACTS": "Tots els contactes",
    "TAGGED_WITH": "Etiquetat amb",
    "NEW_LABEL": "Nova etiqueta",
    "NEW_TEAM": "Nou equip",
    "NEW_INBOX": "Safata d'entrada nova",
    "REPORTS_CONVERSATION": "Converses",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Campanyes",
    "ONGOING": "En marxa",
    "ONE_OFF": "Un fora",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agents",
    "REPORTS_LABEL": "Etiquetes",
    "REPORTS_INBOX": "Safata d'entrada",
    "REPORTS_TEAM": "Equip",
    "REPORTS_PHONE": "Telèfon",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Resum",
    "WALLBOARD_QUEUES": "Cues",
    "DATA_ASSISTANT_CHAT": "Xat",
    "DATA_ASSISTANT_REPORTS": "Informes",
    "NO_WAITING_CALLERS": "cap trucant en espera",
    "WAITING_CALLERS": "{count} trucants en espera",
    "SET_AVAILABILITY_TITLE": "Posa't com",
    "SET_YOUR_AVAILABILITY": "Estableix la vostra disponibilitat",
    "AVAILABILITY_IMPERSONATING": "Bloquejat mentre has iniciat sessió com aquest usuari",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Conversa nova",
    "DRAFT": "Esborrany",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Resum",
    "REAUTHORIZE": "La vostra connexió a la safata d'entrada ha caducat, torna a connectar\n per continuar rebent i enviant missatges",
    "HELP_CENTER": {
      "TITLE": "Centre d'ajuda",
      "ARTICLES": "Articles",
      "CATEGORIES": "Categories",
      "LOCALES": "Localitzacions",
      "SETTINGS": "Configuracions",
      "DICTIONARY": "Diccionari"
    },
    "CHANNELS": "Canals",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Marca fora de línia automàticament",
      "INFO_TEXT": "Permet que el sistema et marqui automàticament fora de línia quan no facis servir l'aplicació o el tauler.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Llegir documents"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Dominis i contactes bloquejats",
    "DESCRIPTION": "Llista de dominis de correu electrònic bloquejats per a aquest compte.",
    "NO_BLOCKED_DOMAINS": "No s'ha trobat cap domini bloquejat.",
    "BLOCKED_CONTACTS_BTN": "Contactes bloquejats"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Facturació",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Pla actual",
      "PLAN_NOTE": "Actualment estàs subscrit al pla **{plan}** amb **{quantity}** llicències",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Gestiona la teva subscripció",
      "DESCRIPTION": "Consulta les teves factures anteriors, edita els teus detalls de facturació o cancel·la la teva subscripció.",
      "BUTTON_TXT": "Ves al portal de facturació"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Necessita ajuda?",
      "DESCRIPTION": "Trobes algun problema en la facturació? Estem aquí per ajudar.",
      "BUTTON_TXT": "Xateja amb nosaltres"
    },
    "NO_BILLING_USER": "El teu compte de facturació s'està configurant. Actualitza la pàgina i torna-ho a provar."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Uh oh! No hem trobat cap compte. Crea un compte nou per continuar.",
    "NEW_ACCOUNT": "Compte nou",
    "SELECTOR_SUBTITLE": "Crear un compte nou",
    "API": {
      "SUCCESS_MESSAGE": "El compte s'ha creat correctament",
      "EXIST_MESSAGE": "El compte ja existeix",
      "ERROR_MESSAGE": "No s'ha pogut connectar amb el servidor Woot. Torna-ho a provar més endavant"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Nom de la companyia",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Envia",
      "CANCEL": "Cancel·la"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Veure totes les dreceres",
    "TITLE": {
      "OPEN_CONVERSATION": "Obrir conversa",
      "RESOLVE_AND_NEXT": "Resol i passa al següent",
      "NAVIGATE_DROPDOWN": "Navega pels elements desplegables",
      "RESOLVE_CONVERSATION": "Resol la conversa",
      "GO_TO_CONVERSATION_DASHBOARD": "Ves al Tauler de converses",
      "ADD_ATTACHMENT": "Afegeix fitxer adjunt",
      "GO_TO_CONTACTS_DASHBOARD": "Ves al tauler de contactes",
      "TOGGLE_SIDEBAR": "Commuta la barra lateral",
      "GO_TO_REPORTS_SIDEBAR": "Anar a la barra lateral Informes",
      "MOVE_TO_NEXT_TAB": "Anar a la pestanya següent de la llista de converses",
      "GO_TO_SETTINGS": "Ves a la configuració",
      "SWITCH_TO_PRIVATE_NOTE": "Canvia a la nota privada",
      "SWITCH_TO_REPLY": "Canvia a Respon",
      "TOGGLE_SNOOZE_DROPDOWN": "Commuta el menú desplegable de posposar",
      "AI_ASSIST_MENU": "Assistència IA",
      "AI_ASSIST_GRAMMAR": "Corregeix la gramàtica",
      "AI_ASSIST_UNIFY_LANG": "Unifica l'idioma del missatge"
    }
  }
}
